import { jsx as _jsx } from "react/jsx-runtime";
import { FormikConsumer } from "formik";
import { styled } from "../../theme";
import { useBlockComponentContext } from "../BlockComponentContext";
import { isInvalid } from "../../form";
const defaultProps = {
    ValidationBlock: styled.div `
    padding: 10px;
    margin: 0 -10px;
    border-radius: 4px;
    margin-bottom: 5px;
    border: 1px solid transparent;
    ${({ isInvalid }) => isInvalid &&
        `
        border: 1px solid #fac1c7;
        background: #fff1f1;
    `};
  `,
};
export const ValidationBlockBoundary = (props) => {
    const { name, children, ValidationBlock } = {
        ...props,
        ...useBlockComponentContext(),
    };
    return (_jsx(FormikConsumer, { children: formik => (_jsx(ValidationBlock, { isInvalid: isInvalid(name, formik), "data-test-id": isInvalid(name, formik), children: children })) }));
};
ValidationBlockBoundary.defaultProps = defaultProps;
